import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AustinPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How does custom software development help my business?",
    answer: `<p>If you own a business and you are looking to excel beyond possibilities, there is no better chance for you to grab than to go with custom software. TekRevol, being an experienced custom software development company and being rated top for Flutter app development company, game development company, and multiple other top software categories, knows what works in the market. We leverage our experience with technology products and various other digital transformation domains to deliver exquisite technology solutions, ensuring digital excellence.</p>`,
  },
  {
    question: "What information do you need from me to start work?",
    answer: `<p>All the information that is essential for your custom solution to be developed is what we need from you. From the target market, preferred features and design flow, complexity and features depth, performance optimization needs, platform independence requirements, and more, we ask you this just to be sure that what you get is the ultimate solution. If you think this is too much information for you to provide, no worries. Our digital experts with years of experience building custom digital solutions, including cloud and application, will be by your side to assist you in extracting the correct information to build the perfect product.</p>`,
  },
  {
    question:
      " Do you provide product support services after the software development is complete?",
    answer: `<p>TekRevol is a full-service digital transformation company that provides complete post-development and post-launch support services to ensure the seamless continuation of the services being provided through the digital product. From periodic routine checks and audits to feature upgrades to experience optimization, our digital experts know what is necessary for your product to reach your audience and make it a success with long-term sustainability. For more information, connect with our experts today or schedule a 1-on-1 call and get all that you want.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{AustinPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
